





















import Vue from "vue";
import { isDeliveryNoticeVisible } from "@/optimizedEncoding/scripts/helpers/deliveryNotice";
import { isBillboardSelected } from "@/shared/scripts/helpers/customer/billingAddress";

export default Vue.extend({
    name: "DeliveryNoticeCallout",
    computed: {
        // Whether a window sign is in the order (the shipping delay only concerns
        // those orders - IO-241).
        hasBillboardInOrder: function(): boolean {
            const getters = this.$store.getters;
            const getTransaction = getters["FormModule/getValueTransaction"];

            // In-session the funnel selection is authoritative: isBillboardSelected
            // is the exact check createOrder uses to tell the backend to ship a
            // sign (paid add-on, the free-in-Premium sign, non-BE removal) and it
            // correctly reflects an opt-out. While that selection state is present,
            // trust it outright - never let the order-derived fallback below
            // override a genuine uncheck.
            const selectionState = getTransaction("optimizedEncoding.selectedPackOptions");
            const funnelSelectionLoaded = !!selectionState && Object.keys(selectionState).length > 0;
            if (funnelSelectionLoaded) {
                return isBillboardSelected(getTransaction, getters["FormModule/getValueOrder"]);
            }

            // Hard-reload fallback: the funnel selection is gone, so derive the
            // sign from the re-fetched order. A paid sign carries a billboardPrice;
            // the Premium pack (FOR_SALE) bundles it for free (no price), so mirror
            // packConfig's isFreeInPack rule. NOTE: on reload we cannot distinguish
            // a genuinely opted-out Premium order from an included one (the order
            // API does not expose hasBillboard), so this may over-show for a rare
            // reloaded opt-out until the backend returns that flag.
            const orderPackage = getters["OrdersModule/package"];
            const currentOrder = getters["OrdersModule/getCurrentOrder"];
            const paidSignInOrder = (orderPackage?.billboardPrice ?? 0) > 0;
            const freeSignInPremium = (currentOrder?.visualizationOption ?? "").toLowerCase() === "premium"
                && currentOrder?.tariff?.transactionType === "FOR_SALE";

            return paidSignInOrder || freeSignInPremium;
        },
        visible: function(): boolean {
            return isDeliveryNoticeVisible() && this.hasBillboardInOrder;
        },
    },
});
